<template>
    <component
        :is="tag"
        :class="colClasses">
        <!-- @slot Слот по-умолчанию -->
        <slot></slot>
    </component>
</template>

<script>
/**
 * `<SbsCol>` - это контейнер для отдельной колонки сетки. Должен быть помещен внутри компонента `<SbsRow>` или элемента (такого как `<div>`), к которому применена класс `row`, или - в случае форм - внутри `<SbsFormRow>` (для получения колонок с более компактными полями).
 */
export default {
    name: 'SbsCol',
    computed: {
        colsClasses() {
            const resultArray = [];

            if (this.cols) resultArray.push(`col-${this.cols}`);

            if (this.sm) resultArray.push(`col-sm-${this.sm}`);

            if (this.md) resultArray.push(`col-md-${this.md}`);

            if (this.lg) resultArray.push(`col-lg-${this.lg}`);

            if (this.xl) resultArray.push(`col-xl-${this.xl}`);

            return resultArray;
        },
        orderClasses() {
            const resultArray = [];

            if (this.order) resultArray.push(`order-${this.order}`);

            if (this.orderSm) resultArray.push(`order-sm-${this.orderSm}`);

            if (this.orderMd) resultArray.push(`order-md-${this.orderMd}`);

            if (this.orderLg) resultArray.push(`order-lg-${this.orderLg}`);

            if (this.orderXl) resultArray.push(`order-xl-${this.orderXl}`);

            return resultArray;
        },
        offsetClasses() {
            const resultArray = [];

            if (this.offset) resultArray.push(`offset-${this.offset}`);

            if (this.offsetSm) resultArray.push(`offset-sm-${this.offsetSm}`);

            if (this.offsetMd) resultArray.push(`offset-md-${this.offsetMd}`);

            if (this.offsetLg) resultArray.push(`offset-lg-${this.offsetLg}`);

            if (this.offsetXl) resultArray.push(`offset-xl-${this.offsetXl}`);

            return resultArray;
        },
        colClasses() {
            const classesArray = [...this.colsClasses, ...this.orderClasses, ...this.offsetClasses];
            const noColsNumber = !this.cols && !this.sm && !this.md && !this.lg && !this.xl;

            if (this.alignSelf) classesArray.push(`align-self-${this.alignSelf}`);

            if (this.col || noColsNumber) classesArray.push('col');

            return classesArray;
        },
    },
    props: {
        /**
         * Вертикальное выравнивание ячейки сетки относительно строки: `start`, `center`, `end`, `baseline` или `stretch`
         */
        alignSelf: {
            type: String,
            default: null,
        },
        /**
         * Устанавливает одинаковую ширину для ячеек колонок сетки
         */
        col: {
            type: Boolean,
            default: false,
        },
        /**
         * Определяет количество колонок, охватываемых ячейкой сетки
         */
        cols: {
            type: [Number, String],
            default: null,
        },
        /**
         * Определяет количество колонок, охватываемых ячейкой сетки для брейкпоинта `sm`
         */
        sm: {
            type: [Boolean, Number, String],
            default: null,
        },
        /**
         * Определяет количество колонок, охватываемых ячейкой сетки для брейкпоинта `md`
         */
        md: {
            type: [Boolean, Number, String],
            default: null,
        },
        /**
         * Определяет количество колонок, охватываемых ячейкой сетки для брейкпоинта `lg`
         */
        lg: {
            type: [Boolean, Number, String],
            default: null,
        },
        /**
         * Определяет количество колонок, охватываемых ячейкой сетки для брейкпоинта `xl`
         */
        xl: {
            type: [Boolean, Number, String],
            default: null,
        },
        /**
         * Количество столбцов, на которые смещена ячейка сетки
         */
        offset: {
            type: [Number, String],
            default: null,
        },
        /**
         * Количество столбцов, на которые смещена ячейка сетки для брейкпоинта `sm`
         */
        offsetSm: {
            type: [Number, String],
            default: null,
        },
        /**
         * Количество столбцов, на которые смещена ячейка сетки для брейкпоинта `md`
         */
        offsetMd: {
            type: [Number, String],
            default: null,
        },
        /**
         * Количество столбцов, на которые смещена ячейка сетки для брейкпоинта `lg`
         */
        offsetLg: {
            type: [Number, String],
            default: null,
        },
        /**
         * Количество столбцов, на которые смещена ячейка сетки для брейкпоинта `xl`
         */
        offsetXl: {
            type: [Number, String],
            default: null,
        },
        /**
         * Порядок отображения ячейки сетки
         */
        order: {
            type: [Number, String],
            default: null,
        },
        /**
         * Порядок отображения ячейки сетки для брейкпоинта `sm`
         */
        orderSm: {
            type: [Number, String],
            default: null,
        },
        /**
         * Порядок отображения ячейки сетки для брейкпоинта `md`
         */
        orderMd: {
            type: [Number, String],
            default: null,
        },
        /**
         * Порядок отображения ячейки сетки для брейкпоинта `lg`
         */
        orderLg: {
            type: [Number, String],
            default: null,
        },
        /**
         * Порядок отображения ячейки сетки для брейкпоинта `xl`
         */
        orderXl: {
            type: [Number, String],
            default: null,
        },
        /**
         * Определяет тег HTML для контейнера
         */
        tag: {
            type: String,
            default: 'div',
        },
    },
};
</script>
